function AccountFilter() {

  return function (input) {
    if (!Number.isInteger(input)) {
      if (input && input != "") {
        let arr = input.split("_");
        let newArr = [];
        for (let word of arr) {
          newArr.push(word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
        }
        return newArr.join(" ");
      }
    }
    else {
      switch (input) {
        case 0:
          return 'Client';
        case 1:
          return 'Accountant';
        case 2:
          return 'Admin';
      }
    }
    return input;
  };

}

export default {
  name: 'AccountFilter',
  fn: AccountFilter
};
